import { UserRole } from "tm-shared/types";

import { isManagerRole } from "@/utils";

export interface RouteManagementCapabilities {
    canViewRoutes: boolean;
    canCreateRoute: boolean;
    canExportRoutes: boolean;
}

export const getRouteManagementCapabilities = (
    role: UserRole,
): RouteManagementCapabilities => {
    const isManager = isManagerRole(role);

    return {
        canViewRoutes: isManager,
        canCreateRoute: isManager,
        canExportRoutes: isManager,
    };
};
